export interface User {
  id: string;
  email: string;
  name?: string;
  avatar_url?: string;
}

export const getUserFromPageMeta = (): User | undefined => {
  const userId = document.querySelector("meta[name='user-id']")?.getAttribute("content");
  const userEmail = document.querySelector("meta[name='user-email']")?.getAttribute("content");
  const userName = document.querySelector("meta[name='user-name']")?.getAttribute("content");
  const userAvatarUrl = document
    .querySelector("meta[name='user-avatar-url']")
    ?.getAttribute("content");

  if (userId && userEmail) {
    return {
      id: userId,
      email: userEmail,
      name: userName ?? undefined,
      avatar_url: userAvatarUrl ?? undefined,
    };
  }

  return undefined;
};
